import { TaskState } from '../../../common/constants/states';
import { UserOrganization } from '../../../common/constants/userOrganization';
import { ITask } from '../../tasks/interfaces/ITask';
import { Evidence } from '../../tasks/types/evidence';
import { TaskTypes } from '../../tasks/types/taskTypes';

export const factsExist = (evidence?: Evidence | null) => {
  return evidence && evidence.facts;
};

const retryableAutomatedTasks = [
  TaskTypes.TRL,
  TaskTypes.MIB,
  TaskTypes.MVR,
  TaskTypes.RX,
  TaskTypes.CRIMINAL_RECORDS,
  TaskTypes.AUTO_MEDICAL_CLAIMS,
];

const isRetryableAutomatedTask = (task: ITask) => {
  return retryableAutomatedTasks.includes(task.taskType);
};

export const evidenceTaskHasRetryOption = (task: ITask): boolean => {
  return isRetryableAutomatedTask(task);
};

export const evidenceTaskHasUploadOption = (task: ITask): boolean => {
  return [TaskState.ERROR, TaskState.WAIVED].includes(task.state);
};

/**
 * Returns whether the given task type is viewable for the user's organization.
 * RULE_REVIEW is viewable only for ETHOS/INTEGRA; ADDITIONAL_DATA is never viewable.
 */
export function isTaskViewable(org: string, taskType: string): boolean {
  return (
    ([
      UserOrganization.ETHOS as string,
      UserOrganization.INTEGRA as string,
    ].includes(org) ||
      taskType !== TaskTypes.RULE_REVIEW) &&
    taskType !== TaskTypes.ADDITIONAL_DATA
  );
}
